import Vue from 'vue'
import * as d3 from 'd3'
import httpManager from "../../util/common";
import {reportYear,metaData} from '../../util/util'
Vue.config.productionTip = false

let vm = {
  delimiters: ['{', '}'],
  name: 'entity-home-sc',
  props: ['oaid'],
  data () {
    return {
      datas: [],
      sta_data: {},
      year: reportYear.report_year_now,
      year_list: reportYear.report_years.slice(0, 3),
      result: null,
      divloading: false
    }
  },
  mounted () {
    this.getSCChartData()
  },
  methods: {
    getSCChartData () {
      let self = this
      self.divloading = true
      let oaid = this.oaid
      let params = new Map()
      params.set('oaid', oaid)
      params.set('year', this.year)
      httpManager('entity_home_sc_overview', params)
        .then(response => {
          self.sta_data = response.data.data.sta_data
          if (response.data.data.result.length > 0) {
            let result = {}
            for(let i in self.year_list){
              result[self.year_list[i]]={
                'cost': 0,
                'rev': 0
              }
            }
            for (let i = 0; i < response.data.data.result.length; i++) {
              result[response.data.data.result[i]['reporting_year']] = {
                'cost': response.data.data.result[i]['cost_exp_b_year'],
                'rev': response.data.data.result[i]['rev_exp_b_year']}
            }
            self.result = result
            self.datas = []
            for (let i = 0; i < 3; i++) {
              if (self.year_list[i] in result) {
                self.datas.push(result[self.year_list[i]].rev)
                self.datas.push(result[self.year_list[i]].cost)
              } else {
                self.datas.push(0)
                self.datas.push(0)
              }
            }
            self.drawBarChart()
          }
          self.divloading = false
        })
        .catch(error => {
          console.log(error)
          self.divloading = false
        })
    },

    drawBarChart () {
      d3.select('#entity-home-sc-total-chart').select('*').remove()
      // 制作画布
      let width = 570;// 画布宽度
      let height = 260;// 画布高度
      let svg = d3.select('#entity-home-sc-total-chart')
        .append('svg').attr("viewBox", [0, 0, width, height])
      // 画布周边的空白
      let padding = {left: 30, right: 30, top: 20, bottom: 50};

      // 定义一个数组
      let datas = this.datas;

      // 定义坐标轴比例尺
      // x轴比例尺
      let ranges = d3.range(datas.length)// ranges是datas数组下标集合的一个数组
      // /*注意:4版本后下面的这种用法好像不可以了
      //   var xScale = d3.scale.ordinal()
      //                  .domain(d3.range(datas.length))
      //                  .rangeRoundBands([0, width - padding.left - padding.right])
      // */
      let revenue_breakdown = this.$t('supplychain.revenue_breakdown')
      let cost_breakdown = this.$t('supplychain.cost_breakdown')
      let revenue_ = this.$t('supplychain.revenue_')
      let cost_ = this.$t('supplychain.cost_')
      let xScale = d3.scaleBand()
        .domain(['2020'+cost_breakdown, '2020'+revenue_breakdown, '2019'+cost_breakdown, '2019'+revenue_breakdown, '2018'+cost_breakdown, '2018'+revenue_breakdown]) // 这里装的是一个数组
        .range([0, width - padding.left - padding.right])

      // y轴比例尺
      // let min = d3.min(datas);
      let max = d3.max(datas);
      let yScale = d3.scaleLinear()
        .domain([0, max])// 值域范围，即y轴的最大最小值
        .range([height - padding.top - padding.bottom, 0]);

      // 定义坐标轴
      // X轴
      let xAxis = d3.axisBottom(xScale);
      // Y轴
      let yAxis = d3.axisLeft(yScale);

      // 矩形之间的空白
      let rectPadding = 58;
      // 添加矩形元素
      let rects = svg.selectAll('.MyRect')
        .data(datas)
        .enter()
        .append('rect')// 添加矩形
        .attr('class', 'MyRect')// 添加类名
        .attr('transform', 'translate(' + padding.left + ',' + padding.top + ')')// 矩形的位置
        .attr('x', function (d, i) { // 生成的矩形距离画布左侧的距离
          if (i % 2 == 0) {
            return (i - 1) * 36 + rectPadding * i + padding.left + 30;
          }
          return (i - 1) * 36 + rectPadding * i + padding.left + 15;
        })
        .attr('y', function (d) { // 生成的矩形距离画布顶部的距离
          return yScale(d);
        })
        .attr('width', 36) // 根据比例尺来计算出矩形的宽度
        .attr('height', function (d) {
          if (d) {
            // 画布高度-距离顶部-距离底部-矩形距离顶部的高算出矩形的高度
            return height - padding.top - padding.bottom - yScale(d)
          } else {
            return 0
          }
        })
        .attr('fill', '#C92525'); // 矩形颜色
      // 添加文字元素
      let texts = svg.selectAll('.MyText')
        .data(datas)
        .enter()
        .append('text')// 添加图形数据
        .attr('class', 'MyText')
        .attr('transform', 'translate(' + padding.left + ',' + padding.top + ')')
        .attr('font-size', 12)
        .attr('x', function (d, i) {
          if (i % 2 == 0) {
            return (i-1) * 38 + 56 * i + padding.left + 15;
          }
          return (i-1) * 38 + 56 * i + padding.left;
        })
        .attr('y', function (d) {
          return 210
        })
        // .attr('dx', function () { // 文字距离矩形左边的距离
        //   return (xScale.bandwidth() - rectPadding*5)/2;
        // })
        // .attr('dy', function (d) { // 文字距离矩形顶部的距离
        //   return 0;
        // })
        .text(function (d, i) {
          if (i % 2 == 0) {
            return revenue_;
          }
          return cost_;
        })
      let text1 = svg.selectAll('.MyText1')
        .data(this.year_list)
        .enter()
        .append('text')// 添加图形数据
        .attr('class', 'MyText1')
        .attr('transform', 'translate(' + padding.left + ',' + padding.top + ')')
        .attr('font-size', 14)
        .attr('color', '#333333')
        .attr('x', function (d, i) {
          return (i - 1) * 38 + 150 * i + padding.left + 72;
        })
        .attr('y', function (d) {
          return 230
        })
        .text(function (d, i) {
          return d
        })
      // 添加坐标轴元素
      // 添加X轴
      // svg.append('g')
      //   .attr('class', 'axis')
      //   .attr('transform', 'translate(' + padding.left + ',' + (height - padding.bottom) + ')')
      //   .call(xAxis)
      // 添加Y轴
      svg.append('g')
        .attr('class', 'axis')
        .attr('transform', 'translate(' + (padding.left + 20) + ',' + padding.top + ')')
        .call(yAxis)
    }
  }
}
Vue.component('entity-home-sc', vm)
export default vm



// WEBPACK FOOTER //
// ./src/entity/js/entity_home_sc.js